import i18n from "../../../lang/base";
import { FONT } from "../../../value/staticValues";
import { getTimestampToDate, parseKeyValue, parseLocaleDatetime } from "../../../common/util";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";
import { ReactComponent as StorageImg } from "../../../img/ico-vpc-list-storage.svg";

import { ListActionMenu, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import PodServiceAdd from "./PodServiceAdd";
import PodServiceUpdate from "./PodServiceUpdate";
import { DropdownType } from "../../base/CustomDropdown";


interface portData {
    port: number,
    target_port: number
}

export interface PodServiceData {
    service_id: string;
    service_name: string;
    service_description: string;
    service_type_code: string;
    service_yaml: string;
    labels: string;
    cluster_ip_address: string;
    load_balance_ingress_ip_address: string;
    selector: string;
    ports: portData[]
    up_yn: boolean,
    create_ts: string;
    update_ts: string;
    namespace: {
        namespace_id: string;
        namespace_name: string;
    },
    container_cluster: {
        container_cluster_id: string;
        container_cluster_name: string;
    },
    project: {
        project_id: string;
        project_name: string;
    }
}


export const initPodServiceData = {
    service_id: '',
    service_name: '',
    service_description: '',
    service_type_code: '',
    service_yaml: '',
    labels: '',
    cluster_ip_address: '',
    load_balance_ingress_ip_address: '',
    selector: '',
    ports: [
        {
            port: 0,
            target_port: 0
        }
    ],
    up_yn: false,
    create_ts: '',
    update_ts: '',
    namespace: {
        namespace_id: '',
        namespace_name: '',
    },
    container_cluster: {
        container_cluster_id: '',
        container_cluster_name: '',
    },
    project: {
        project_id: '',
        project_name: '',
    }
}


export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("POD_SERVICE_CREATE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH_WITH_ICON,
            code: "POD_SERVICE_CREATE",
            imgComponent: <AddButtonImg/> ,
            activeImgComponent: <AddButtonActiveImg />,
            inactiveImgComponent: <AddButtonImg style={{filter: "opacity(0.5) grayscale(0.5)"}}/>,
        },
    },
    {
        id: 2,
        name: i18n.t("DELETE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.CANCEL,
            code: "POD_SERVICE_DELETE",
        },
    },
    {
        id: 3,
        name: i18n.t("SYNC_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH,
            code: "POD_SERVICE_SYNC",
        }
    },
];

export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("SERVICE_NAME_TEXT"),
        accessor: "service_name",
        disableSortBy: false,
        style: {
            width: "170px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("SERVICE_TYPE_TEXT"),
        accessor: "service_type_code",
        disableSortBy: false,
        style: {
            width: "160px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center", justifyContent: "center",
                width: value === "NODEPORT" ? 80 : value === "CLTIP" ? 100 : 120, height: 20,
                paddingLeft: 10, paddingRight: 10,
                borderRadius: 5,
                backgroundColor: value === "NODEPORT" ? "#e8edfb" : value === "CLTIP"? "#ddf2e8" : "#ddf2e8",
                fontFamily: FONT.MEDIUM,
                fontSize: 12,
                color: value === "NODEPORT" ? "#4973cd" : value === "CLTIP" ? "#5b9782" : "#5b9782"
            }}>
                {value === "NODEPORT" ? "NodePort" : value === "CLTIP" ? "ClusterIP" : "LoadBalancer"}
            </div>
        )
    },
    {
        Header: i18n.t("PORT_TEXT"),
        accessor: "ports",
        disableSortBy: true,
        style: {
            width: "200px",
        },
        Cell: ({ cell: {value} }) => (
        <div style={{...className.normalTextContainer, ...className.blueText}}>
            {value.map((port, index) => {
                return (
                <div style={{marginRight: 5,}} key={index}>
                    {port.node_port ? "(" + port.node_port+ ")" : ""}{port.port}{"=>Target:" + port.target_port}
                </div>
                )})
            }
        </div>)
    },
    {
        Header: i18n.t("CLUSTER_IP_TEXT"),
        accessor: "cluster_ip_address",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (
        <div style={{...className.normalTextContainer, ...className.greenText, display: "flex"}}>{value ? value : ""}</div>)
    },
    {
        Header: i18n.t("LOAD_BALANCER_INGRESS_IP"),
        accessor: "load_balance_ingress_ip_address",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (
        <div style={{...className.normalTextContainer, display: "flex"}}>{value ? value : ""}</div>)
    },
    {
        Header: i18n.t("SELECTOR_TEXT"),
        accessor: "selector",
        disableSortBy: true,
        style: {
            width: "200px",
        },
        Cell: ({ cell: {value} }) => (
        <div style={{...className.normalTextContainer, ...className.purpleText, display: "flex"}}>{value}</div>)
    },
    {
        Header: i18n.t("LABEL_TEXT"),
        accessor: "labels",
        disableSortBy: true,
        style: {
            width: "200px",
        },
        Cell: ({ cell: {value} }) => (
        <div style={{display: "flex", alignItems: "center"}}>
             <div style={{
                display: "flex", alignItems: "center", justifyContent: "center",
                minWidth: 20, height: 20,
                paddingLeft: 10, paddingRight: 10,
                marginRight: 4,
                borderRadius: 10,
                backgroundColor: "#e6ebf2",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: "#9ea0a5"}}>
                    {value}
            </div>
        </div>)
    },
    {
        Header: i18n.t("CLUSTER_TEXT"),
        accessor: "container_cluster",
        disableSortBy: true,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.greenText}}>{value?.container_cluster_name ? value?.container_cluster_name : "-"}</div>)
    },
    {
        Header: i18n.t("NAMESPACE_TEXT"),
        accessor: "namespace",
        disableSortBy: true,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.blueText}}>{value?.namespace_name ? value?.namespace_name : "-"}</div>)
    },
    {
        Header: i18n.t("PROJECT_TEXT"),
        accessor: "project",
        disableSortBy: true,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.blueText}}>{value?.project_name ? value?.project_name : "-"}</div>)
    },
    {
        Header: i18n.t("UPDATE_DATE_TEXT"),
        accessor: "update_ts",
        disableSortBy: false,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: false,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
];

export const podServiceAddModalContent = {
    title: i18n.t("POD_SERVICE_CREATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        },
    ],
    innerComponent: <PodServiceAdd />,
}

export const podServiceUpdateModalContent = {
    title: i18n.t("POD_SERVICE_DETAIL_INFO_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("UPDATE_SAVE_TEXT")
        },
    ],
    innerComponent: <PodServiceUpdate />,
}

export const serviceTypes:DropdownType[] = [
    {
        label: i18n.t("SERVICE_CLUSTERIP_TYPE_TEXT"),
        value: "CLTIP"
    },
    {
        label: i18n.t("SERVICE_NODEPORT_TYPE_TEXT"),
        value: "NODEPORT"
    },
    {
        label: i18n.t("SERVICE_LOADBALANCER_TYPE_TEXT"),
        value: "LB"
    },
]

const className = {
    statusContainer: {
        width: 56,
        display: "flex", Jusitipy: "center", justifyContent: "center",
        borderRadius: 10,
        backgroundColor: "#b6bfce",
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#fff"
    },
    statusImg: {
        marginRight: 3
    },
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    dateContainer: {
        color: "#9ea0a5",
    },
    greenText: {
        color: "#3a8344"
    },
    blueText: {
        color: "#0853fb"
    },
    purpleText: {
        color: "#7066f1"
    },
}